// src/config/players.ts — Yerel çok oyunculu sözleşmesi: kaç oyuncu, hangi renk, hangi pad yuvası.
//
// Neden ayrı ve config'de: bu sabitleri hem menü (imleç rengi), hem HUD (etiket/kart rengi), hem girdi katmanı
// (oyuncu → pad eşlemesi) okuyor. Tek kaynak olmazsa üç yerde ayrı renk tablosu oluşur ve zamanla ayrışır.
// three.js import ETMEZ (config kuralı); renkler CSS dizgesi olarak durur, view tarafı gerekirse sayıya çevirir.

/** Aynı ekranda en fazla dört kişi (dört pad) — KOLTUK tavanı. Arena 8 dövüşçü taşıyor (MAX_FIGHTERS); ağ maçında
 *  sekizi de insan olabilir, bu sabit yalnız TEK MAKİNEDEKİ oyuncu sayısını sınırlar (NETWORK.md §2.4: koltuk
 *  indeksi 0..3 ile dövüşçü kimliği 0..7 AYRI kavramlardır, karıştırma). */
export const MAX_LOCAL_PLAYERS = 4;

/** Oyuncu rengi: P1 oyunun sarısı (mevcut vurgu rengi), diğerleri birbirinden ve arenanın mavisinden ayrık. */
export interface PlayerColor {
  /** CSS rengi (HUD etiketi, menü imleci). */
  css: string;
  /** three.js için 0xRRGGBB karşılığı (aynı renk; view tarafı dönüştürme yapmasın). */
  hex: number;
  /** Menüde ve HUD'da görünen kısa ad. */
  label: string;
}

/**
 * SEKİZ renk — arena 8 dövüşçü taşıyor ve ağ maçında hepsi insan olabiliyor (NETWORK.md kararı 2).
 * Önceden dört renk vardı ve `playerColor` 3'ten sonra SESSİZCE P1 sarısını tekrar veriyordu: beş kişilik bir
 * maçta iki oyuncu aynı renkte görünürdü ve hangi etiketin kimin olduğu okunamazdı.
 * İlk dördün SIRASI ve DEĞERİ korundu (mevcut kanepe oyununun görünümü değişmesin).
 */
export const PLAYER_COLORS: readonly PlayerColor[] = [
  { css: '#ffd43b', hex: 0xffd43b, label: 'P1' },   // sarı — oyunun mevcut vurgu rengi
  { css: '#4dabf7', hex: 0x4dabf7, label: 'P2' },   // mavi
  { css: '#51cf66', hex: 0x51cf66, label: 'P3' },   // yeşil
  { css: '#ff8787', hex: 0xff8787, label: 'P4' },   // mercan (kırmızı, HUD'daki tehlike kırmızısından açık)
  { css: '#b197fc', hex: 0xb197fc, label: 'P5' },   // lavanta
  { css: '#ffa94d', hex: 0xffa94d, label: 'P6' },   // turuncu
  { css: '#63e6be', hex: 0x63e6be, label: 'P7' },   // turkuaz
  { css: '#f783ac', hex: 0xf783ac, label: 'P8' },   // pembe
];

/** Oyuncu indeksine göre renk (taşarsa P1'e döner — çağıranlar dizi sınırını düşünmesin). */
export const playerColor = (i: number): PlayerColor => PLAYER_COLORS[i] ?? PLAYER_COLORS[0]!;

/**
 * Oyuncu → pad yuvası eşlemesi.
 * P1 klavyeyi VE ilk pad'i birlikte kullanır (tek kişilik oyun bugünkü gibi kalsın: klavyeyle başlayıp pad'e geçmek
 * ayrı bir "katılma" istemesin). P2–P4 yalnız pad'dir; menüde A'ya basarak katılırlar.
 * NOT: gerçek pad yuvası sabit değildir (bkz. input/gamepad.ts `resolvePadIndex`); buradaki sıra "kaçıncı bağlı pad"
 * anlamındadır, ham `navigator.getGamepads()` indeksi değil.
 */
export const KEYBOARD_PLAYER = 0;

/** Bir oyuncu yuvası: hangi dövüşçü, hangi pad (sıra), hangi karakter seçili, kilitlendi mi. */
export interface LocalPlayer {
  /** 0..3 — renk ve pad sırası bu indeksten gelir. */
  index: number;
  /** Maçtaki dövüşçü kimliği (menüde henüz atanmamışsa −1). */
  fighterId: number;
  /** Kaçıncı bağlı pad (0 tabanlı). P1 klavyeyle de oynayabildiği için −1 olabilir. */
  padSlot: number;
  /** Seçili karakterin CHARACTERS içindeki indeksi. */
  charIdx: number;
  /** Menüde seçimini onayladı mı (A). */
  ready: boolean;
}
